export function isBot() {
  // Check user agent for common bot patterns
  const userAgent = navigator.userAgent.toLowerCase();
  const botPatterns = [
    'googlebot',
    'google-page-speed',
    'bingbot',
    'slurp',
    'duckduckbot',
    'baiduspider',
    'yandexbot',
    'facebookexternalhit',
    'twitterbot',
    'rogerbot',
    'linkedinbot',
    'embedly',
    'quora link preview',
    'showyoubot',
    'outbrain',
    'pinterest',
    'developers.google.com/+/web/snippet',
    'slackbot',
    'vkshare',
    'w3c_validator',
    'redditbot',
    'applebot',
    'whatsapp',
    'flipboard',
    'tumblr',
    'bitlybot',
    'skypeuripreview',
    'nuzzel',
    'discordbot',
    'google page speed',
    'qwantify',
    'pinterestbot',
    'bitrix link preview',
    'xing-contenttabreceiver',
    'chrome-lighthouse',
    'telegrambot',
    'integration-test',
    'zhihu',
    'prerender',
    'headlesschrome',
    'lighthouse',
    'chrome_crawler',
    'phantomjs',
    'slimerjs',
    'node_modules',
    'jsdom',
    'selenium',
    'webdriver',
    'bot',
    'crawler',
    'spider',
    'scraper',
  ];

  // Check if any bot pattern matches
  if (botPatterns.some((pattern) => userAgent.includes(pattern))) {
    return true;
  }

  // Check for missing expected properties
  if (
    typeof window.outerHeight === 'undefined' ||
    typeof window.outerWidth === 'undefined' ||
    window.outerHeight === 0 ||
    window.outerWidth === 0
  ) {
    return true;
  }

  return false;
}
